import { ApiOptions } from '../../api-options.decorator';

import { ApiBaseMidBack } from './base';
import { RoleViewModel } from './types/roleViewModel';

/**
 * @internal
 */
export class ApiMidbackRole extends ApiBaseMidBack {
  @ApiOptions({ channel: 'accessControl.roles.get' })
  getRoles() {
    return this.get<RoleViewModel[]>('/role/external-roles-with-capacities');
  }
}
